import React from 'react';
import { PropTypes } from 'prop-types';
import { Typography } from '@mui/material';

const SuccessMessage = ({ message, ...props }) => {
    if (!message) return null;

    return (
        <Typography
            gutterBottom
            align="center"
            variant="caption"
            component="p"
            color="success.main"
            {...props}
        >
            {message}
        </Typography>
    );
};

SuccessMessage.propTypes = {
    message: PropTypes.string,
};

export default SuccessMessage;
